import { MappedAnswer, ValueAnswer } from '../../components/context/SurveyPageContext';

const defaultAnswer = (questionId: number): ValueAnswer => ({
  question: { id: questionId },
  value: '',
});

const getValueAnswer = (
  mappedAnswers: Map<number, MappedAnswer>,
  questionId: number,
): ValueAnswer => {
  if (mappedAnswers.has(questionId)) {
    return (mappedAnswers.get(questionId) as ValueAnswer) || defaultAnswer(questionId);
  }

  return defaultAnswer(questionId);
};

export default getValueAnswer;
